import React, { Fragment, ReactElement, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import ModalDialog from 'src/components/ModalDialog';
import { ILoadState, IRack, INodeListDisplaySummary, } from 'src/types';
import { FormInput } from 'src/components/Form';
import API from '@sesame/web-api';
import Alert, { AlertTypes } from 'src/components/AlertDisplay';
import { Spinner } from 'src/components/Spinner';


interface IEditLooseNodeProps {
  partNumber: string;
  nodes: INodeListDisplaySummary;
  onEditSave: () => Promise<void>;
}

type IFormData = { quantity: string } & { [key: string]: string };
type fieldNames = keyof IFormData;

export const EditLooseNodes = ({ partNumber, nodes, onEditSave }: IEditLooseNodeProps) => {
  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const quantity = nodes.serialized.length + nodes.unserialized.length;
  const [formData, setFormData] = useState<IFormData>({ quantity: `${quantity}` });
  const [validation, setValidation] = useState<fieldNames[]>([]);

  const sampleNode = nodes.serialized.length ? nodes.serialized[0] : nodes.unserialized[0];

  const dialogId = 'editqty-' + partNumber.replace(':', '-');
  const cancel = (event: React.UIEvent<HTMLAnchorElement>) => {
    setFormData({ quantity: `${quantity}` });
    const el = document.getElementById(dialogId);
    if (el) {
      el.click();
    }
  }

  const saveEdit = (event: React.UIEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    getAccessTokenSilently().then(accessToken => {
      const qtyDelta = +formData.quantity - quantity;
      if (qtyDelta > 0) {
        const sample = nodes.unserialized.length ? nodes.unserialized[0] : nodes.serialized[0];
        sample.parentId = undefined;
        API.post(accessToken, `/api/v1/component?bom=true&quantity=${qtyDelta}`, sample
        ).then(res => {
          onEditSave();
          const el = document.getElementById(dialogId);
          if (el) {
            el.click();
          }
        }).catch(err => {
          Alert(AlertTypes.ERROR, err.message);
        });
      } else {
        const nodeList = [...nodes.unserialized.map(n => n.componentId), ...nodes.serialized.map(n => n.componentId)].slice(0, -qtyDelta);

        Promise.all((() => {
          return nodeList.map(n => Promise.resolve(API.delete(accessToken, `/api/v1/component/${n}`, {})));
        })()
        ).then(values => {
          Alert(AlertTypes.SUCCESS, `${nodeList.length} components removed`);
          onEditSave();
          const el = document.getElementById(dialogId);
          if (el) {
            el.click();
          }
        }).catch(err => {
          Alert(AlertTypes.ERROR, err.message);
        });
      }
    });
  }


  const formChange = (item: fieldNames, event: React.FormEvent<HTMLInputElement | HTMLSelectElement>) => {
    const newFormData = { ...formData };
    newFormData[item] = event.currentTarget.value;

    setFormData(newFormData);
    if (!parseInt(newFormData.quantity)) {
      setValidation(['quantity'])
    } else {
      setValidation([]);
    }
  }

  if (isLoading) {
    return <Spinner />
  }
  return <ModalDialog
    id={dialogId}
    title={`Edit Loose Nodes: ${sampleNode.partNumber} : ${sampleNode.revision}`}
    icon="pencil"
    buttonText="Edit"
  >
    <div className="uk-align-right">
      <FormInput
        label="Quantity"
        name="quantity"
        changeFn={formChange}
        data={formData}
        validation={validation}
      />
      <p className="uk-align-right">
        <a className="uk-button" onClick={(e) => cancel(e)}>Cancel</a>
        <a className="uk-button uk-button-primary" onClick={(e) => saveEdit(e)}>Save</a>
      </p>
    </div>
  </ModalDialog>

}
